import React from 'react';
import { faSquare, faSquareCheck, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from './loading';

export default class SelectHistory extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSelectHistoryChange = (key) => {
        this.props.onSelectHistoryChange(key);
    }

    confirmDelete = (e, key) => {
        e.stopPropagation();
        if (window.confirm('削除しますが、よろしいですか？')) {
            this.props.onDeleteHistory(key);
        }
    }

    confirmAllDelete = () => {
        if (window.confirm('すべて削除します。本当によろしいですか？')) {
            this.props.onAllDeleteHistory();
        }
    }

    render() {
        const history_list = [];
        let selected_key = '';
        if (this.props.selected_history) {
            selected_key = this.props.selected_history.key;
        }
        for(const h of this.props.calc_histories) {
            history_list.push(
                <div className={selected_key === h.key ? 'check-select select-block-1' : 'no-check-select select-block-1'} onClick={() => this.handleSelectHistoryChange(h.key)}>
                    {
                        selected_key === h.key &&
                        <div className="select-block-1-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                    }
                    {
                        selected_key !== h.key &&
                        <div className="select-block-1-1"><FontAwesomeIcon icon={faSquare} /></div>
                    }
                    <div className="select-block-1-2">{h.label}</div>
                    <button className="select-block-1-3" onClick={(e) => this.confirmDelete(e, h.key)}>
                        <FontAwesomeIcon icon={faTrashCan} />&nbsp;削除
                    </button>
                </div>
            );
        }
        return (
            <div className={`select-history-flex ${this.props.className ?? ''}`}>
                <h1 className="bb-1px-solid">栄養計算履歴</h1>
                <div className="select-group">
                    {
                        history_list.length == 0 &&
                        <div>栄養計算履歴がありません。</div>
                    }
                    {
                        history_list.length > 0 &&
                        history_list
                    }
                </div>
                <button className="store-button" disabled={history_list.length === 0} onClick={() => this.confirmAllDelete()}>計算履歴をすべて削除</button>
            </div>
        );
    }
}